var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnotationHotspot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 51,
    r: 13,
    stroke: "#EECB4E",
    strokeWidth: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 51,
    cy: 51,
    r: 32,
    stroke: "#EECB4E",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26 1H1V26M76 1H101V26M1 76V101H26M101 76V101H76",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotationHotspot);
export default __webpack_public_path__ + "static/media/annotation_hotspot.0d445c637aef302fe59050f13b86bff1.svg";
export { ForwardRef as ReactComponent };